import GetAllResourceEntriesInteractor from "../../core/interactor/app/crud/GetResourceEntriesInteractor";
import { IOrganisationIndex } from "../model/OrganisationIndex";
import OrganisationIndexMapper from "../service/OrganisationIndexMapper";
import OrganisationIndexParamMapper from "../service/OrganisationIndexParamMapper";

export default class GetAllOrganisationIndexesInteractor {
  private resource: GetAllResourceEntriesInteractor<IOrganisationIndex>;

  constructor({ getAllResourceEntries }: any) {
    this.resource = getAllResourceEntries;
  }

  async execute(organisationId: number) {
    return this.resource.execute(
      `organisations/${organisationId}/indexes`,
      OrganisationIndexMapper,
      OrganisationIndexParamMapper
    );
  }
}
